import React from "react";

export default class ReviewPagination extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: this.props.page ? this.props.page : 1,
            totalPages: this.props.totalPages
        };
    }

    componentWillReceiveProps(nextProps, nextContext){
        if(this.state.page !== nextProps.page) this.setState({...nextProps});
    }

    prevPage = () => { if(this.state.page > 1) this.props.onChange( parseInt(this.state.page) - 1 ) };

    nextPage = () => { if(this.state.page < this.state.totalPages) this.props.onChange( parseInt(this.state.page) + 1) };

    render = () =>
        <div className="row padding-top">
            <div className="small-12 columns text-center padding-top padding-bottom">
                Showing Page { this.state.page } of { this.state.totalPages } <br /><br />
                { this.state.page > 1 && <span onClick={ this.prevPage } className="button gold no-icon"><i className="fa fa-long-arrow-left"></i> Prev Page</span> }
                { this.state.page < this.state.totalPages && <span onClick={ this.nextPage } className="button gold">Next Page</span> }
            </div>
        </div>
}